export default __webpack_public_path__ + "static/media/shield.cf0f6a81.png";